export default function registerOutsideClickListener(elementSelector, callback) {
  const outsideClickListener = event => {
    event.stopPropagation()

    if (event.target.closest(elementSelector) === null) {
      callback()
      document.removeEventListener('click', outsideClickListener)
    }
  }

  document.addEventListener('click', outsideClickListener)
}
